import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const SERVICES = [
  { key: 'svc1', icon: 'ri-advertisement-line', titleKey: 'svc1Title', descKey: 'svc1Desc' },
  { key: 'svc2', icon: 'ri-edit-2-line', titleKey: 'svc2Title', descKey: 'svc2Desc' },
  { key: 'svc5', icon: 'ri-line-chart-line', titleKey: 'svc5Title', descKey: 'svc5Desc' },
  { key: 'svc6', icon: 'ri-lightbulb-flash-line', titleKey: 'svc6Title', descKey: 'svc6Desc' },
];

export default function Services() {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#F7F8FA] text-[#E53935] text-xs font-semibold tracking-wider uppercase mb-5 border border-gray-100">
              {t('trafficMaster.servicesTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#111111] leading-tight max-w-3xl mx-auto">
              {t('trafficMaster.servicesTitle')}{' '}
              <span className="text-[#E53935]">{t('trafficMaster.servicesTitleHighlight')}</span>
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((svc, i) => (
            <ScrollReveal key={svc.key} delay={i * 0.08}>
              <div className="group bg-white border border-gray-100 rounded-2xl p-8 hover:shadow-[0_12px_48px_rgba(0,0,0,0.06)] hover:border-[#E53935]/20 transition-all duration-400 cursor-pointer h-full">
                <div className="w-12 h-12 rounded-xl bg-[#E53935]/5 flex items-center justify-center mb-5 group-hover:bg-[#E53935]/10 transition-colors duration-300">
                  <i className={`${svc.icon} text-[#E53935] text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-[#111111] mb-2">
                  {t(`trafficMaster.${svc.titleKey}`)}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {t(`trafficMaster.${svc.descKey}`)}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}